import { useApi } from 'utils'
import * as yup from "yup"
import toast from 'react-hot-toast'
import { Controller, FormProvider, useFieldArray, useForm, useWatch } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { ActionButton, BaseTable, Button, Card, HeaderMenu, Input, Loading, PaginationData, TableNumber, Select, DateInput } from 'components'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaPlus, FaRegSave } from 'react-icons/fa'
import { CreateModal as PopupReligion } from "../../../../Setup/Preference/Religion/components/CreateModal"
import { CreateModal as PopupDivisi } from "../../../../Setup/Preference/Divisi/components/CreateModal";
import { CreateModal as PopupDepartement } from "../../../../Setup/Preference/Departement/components/CreateModal";
import { CreateModal as PopupEmploymentTitle } from "../../../../Setup/Preference/JobPosition/components/CreateModal";
import { CreateModal as PopupMainLocation } from "../../../../Setup/Preference/Location/components/CreateModal";
import { CreateModal as PopupSalaryType } from "../../../../Setup/Preference/SalaryType/components/CreateModal";
import { useEffect, useState } from 'react'
import { useDetail } from '../utils' 
import { StatusEnum } from '..'
import { PaginationState } from 'types'
import { useCountry, useProvince, useRegency, useSubdistrict, useVillage } from 'pages/Setup/Preference/Location/components/FormSection/utils'
import { EmployeeReview } from '../types'
import moment from 'moment'
import { useDepartement, useDivisi, useGroupPosition, useJobsPosition, useMainLocation, useReligion, useSalaryType } from 'pages/Card/Transaction/CreateNewEmployee/components/FormSection/utils'

const default_pagination_value = {
  total: 0,
  page: 1,
  limit: 50,
  pages: 1,
  keyword: "",
}

export const ReviewEmployee = () => {
  const navigate = useNavigate()
  const api = useApi()
  const location = useLocation()
  const dataPage = location?.state

  const dataTypeNationality = [
    { value: "1", label: "KTP" },
    { value: "2", label: "Passport" },
  ]
  const dataMaritalStatus = [
    { value: "1", label: "Single" },
    { value: "2", label: "Married" },
  ]
  const dataGender = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
  ]

  const [pagination, setPagination] = useState<PaginationState & { identity_batch?: string, file_status?: number }>({ ...default_pagination_value, identity_batch: dataPage?.identity_batch, file_status: dataPage?.status! })
  const dataSingle = useDetail(pagination)

  const [modalConfig, setModalConfig] = useState({ show: false, action: "", data: {} })
  const [checkedIndexes, setCheckedIndexes] = useState<number[]>([]);
  
  const dataReligion = useReligion()
  const dataMainLocation = useMainLocation()
  const dataDivision = useDivisi()
  const dataDepartement = useDepartement()
  const dataEmploymentTitle = useJobsPosition()
  const dataRole = useGroupPosition()
  const dataSalaryType = useSalaryType()
  const productCountry = useCountry()
  const productProvince = useProvince()
  const productRegency = useRegency()
  const productSubdistrict = useSubdistrict()
  const productVillage = useVillage()

  const isLoadingArray = [
    dataSingle?.isLoading,
    dataReligion?.isLoading,
    dataMainLocation?.isLoadingMainLocation,
    dataDivision?.isLoading,
    dataEmploymentTitle?.isLoading,
    dataRole?.isLoading,
    dataSalaryType?.isLoading,
    productCountry?.isLoading,
    productProvince?.isLoading,
    productRegency?.isLoading,
    productSubdistrict?.isLoading,
    productVillage?.isLoading
  ];
  
  const tableLoading = isLoadingArray.some(Boolean);

  const validationSchema = yup.object().shape({ datavalue: yup.array().label("Data list").defined() })
  const methods = useForm<any>({
    defaultValues: { datavalue: "" },
    resolver: yupResolver(validationSchema)
  })
  const { fields } = useFieldArray({ control: methods.control, name: "datavalue" })
  const dataReview = useWatch({ control: methods.control, name: "datavalue" });

  const hasEmptyFields = () => dataReview?.some((item: any) => !item?.employee_name )
  const isDisabled = dataReview?.length > 0 && hasEmptyFields();

  const getSelectedData = () => {
    if(dataReview) {
      return dataReview?.filter((_: any, index: any) => checkedIndexes?.includes(index));
    }
  };
  const selectedData = getSelectedData();

  const handleCreateSingle = () => {
    return new Promise<void>((resolve) => {
      const payloadMapper = selectedData?.length !== 0 ? selectedData : dataReview
      
      toast.promise(
        api.post(`/import-employee/posting-employee`, payloadMapper),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => {
        dataSingle.refetch()
        selectedData?.length === 0 && navigate(-1)
        setCheckedIndexes([])
      })
      .catch(() => {
        // dataSingle.refetch()
        setCheckedIndexes([])
      })
      .finally(resolve)
    })
  }
  const handleUpdateSingle = (data: EmployeeReview) => {

    return new Promise<void>((resolve) => {
      toast.promise(
        api.post(`/import-employee/posting-employee`, [data]),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => dataSingle.refetch())
      .catch(() => {})
      .finally(resolve)
    })
  }
  const handleDeleteSingle = (id: number) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete(`/import-employee/delete-single/${id}`),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => dataSingle.refetch())
      .catch(() => dataSingle.refetch())
      .finally(resolve)
    })
  }
  const handleCheckboxChange = (index: number) => {
    setCheckedIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };
  const handleCheckAllChange = () => {
    if (checkedIndexes.length === dataReview.length) {
      setCheckedIndexes([]);
    } else {
      setCheckedIndexes(dataReview.map((_: any, index: any) => index));
    }
  };

  const inputClass = "my-[-4px]! mx-[-8px]!"
  const borderTH = "border-2 border-[#A6AEBF]"

  useEffect(() => {
    if (dataSingle?.data?.payload) {
      methods.reset({ datavalue: dataSingle?.data?.payload });
    }
    // eslint-disable-next-line
  }, [dataSingle?.data?.payload, methods.reset]);

  if(dataSingle?.isLoading) {
    return (
      <section className="container pt-5  gap-5 flex flex-col">
        <HeaderMenu title="REVIEW EMPLOYEE IMPORT" />

        <Card>
          <Card.Body>
            <Loading loading={dataSingle?.isLoading} />
          </Card.Body>
        </Card>
      </section>
    )
  }

  return (
    <section className="container gap-5 flex flex-col">
      <HeaderMenu title="REVIEW EMPLOYEE IMPORT" />
      <div id="root"></div>
      <div id="root-datepicker"></div>

      <FormProvider {...methods}>
        <div className="overflow-auto max-h-[500px]">
          <BaseTable>
            <thead className='bg-[#EEEEEE] sticky top-0 z-[1]'>
              <tr>
                <th className={borderTH}>NO</th>
                <th className={borderTH}>FULL NAME</th>
                <th className={borderTH}>TYPE OF NATIONALITY</th>
                <th className={borderTH}>ID NUMBER</th>
                <th className={borderTH}>DATE OF BIRTH</th>
                <th className={borderTH}>MARTIAL STATUS</th>
                <th className={borderTH}>RELIGION</th>
                <th className={borderTH}>HANDPHONE</th>
                <th className={borderTH}>EMAIL</th>
                <th className={borderTH}>COUNTRY</th>
                <th className={borderTH}>PROVINCE</th>
                <th className={borderTH}>REGENCY</th>
                <th className={borderTH}>SUBDISTRICT</th>
                <th className={borderTH}>VILLAGE</th>
                <th className={borderTH}>ADDRESS</th>
                <th className={borderTH}>DATE START</th>
                <th className={borderTH}>MAIN LOCATION</th>
                <th className={borderTH}>DIVISION</th>
                <th className={borderTH}>DEPARTMENT</th>
                <th className={borderTH}>EMPLOYMENT TITLE</th>
                <th className={borderTH}>ROLE MANAGEMENT</th>
                <th className={borderTH}>GENDER</th>
                <th className={borderTH}>SALARY TYPE</th>
                <th className={borderTH}>STATUS</th>
                {dataPage?.status === 1 && <th className={borderTH} rowSpan={2}>ACTION</th>}
                {dataPage?.status === 1 && <th className={borderTH} rowSpan={2}>
                  SUBMIT<br/>ITEMS
                  <div>
                    <input
                      type='checkbox'
                      className='w-[22px] h-[22px] checkbox checkbox-primary mt-2'
                      checked={checkedIndexes.length === dataReview.length}
                      onChange={handleCheckAllChange}
                      >
                      
                    </input>
                  </div>
                </th>}
              </tr>
            </thead>
            <tbody>
              {tableLoading ? <tr><td colSpan={44}><div className='flex justify-start ml-12'><Loading loading /></div></td></tr> : fields?.length === 0
                ? <tr><td className="text-center" colSpan={44}>No Data Available</td></tr>
                : fields.map((field, key) => {

                  const idexValue = dataReview?.[key]
                  const previewId = dataReview?.[key]?.preview_id
                  const status = dataReview?.[key]?.status
                  const isProfileDisable = ![ "employee_name" ].every((field) => dataReview?.[key]?.[field]);

                  return (
                    <tr key={field.id}>
                      <td className={borderTH}>{TableNumber({ dataLength: dataSingle?.data?.pagination_data?.size, pageCurrent: pagination?.page, index: key, limit: pagination.limit, totalData: pagination?.total })}</td>

                      {/* FULL NAME */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.employee_name`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              inputClass={!dataReview?.[key]?.employee_name ? "!input-error" : ""}
                              className={`${inputClass} w-[300px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                            />
                          )}
                        />
                      </td>

                      {/* TYPE OF NATIONALITY */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.type_nationality`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Type Of Nationality"
                              options={dataTypeNationality}
                              value={field.value ? dataTypeNationality.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>
                      
                      {/* ID NUMBER  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.nomor`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => {
                                const result = e.target.value.replace(/[^\d,]/g, '').replace(/[^\d.]/g, '')
                                field.onChange(result)
                              }}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* DATE OF BIRTH  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.birthdate`}
                          render={({ field, fieldState }) => (
                            <div className='w-[150px]'>
                              <DateInput
                                portalId="root-datepicker"
                                className={`${inputClass}`} 
                                error={fieldState.error?.message}
                                disabled={isProfileDisable}
                                placeholderText="Input date of birth"
                                ref={field.ref}
                                selected={field.value ? moment(field.value).toDate() : null}
                                onChange={value => field.onChange(moment(value).format("YYYY-MM-DD"))}
                              />
                            </div>
                          )}
                        />
                      </td>

                      {/* MARITAL STATUS */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.marital_status`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Marital Status"
                              options={dataMaritalStatus}
                              value={field.value ? dataMaritalStatus.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* RELIGION */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.religion_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select Religion"
                                isLoading={dataReligion?.isLoading}
                                options={dataReligion?.data}
                                value={field.value ? dataReligion?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "RELIGION" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* HANDPHONE  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.handphone`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => {
                                const result = e.target.value.replace(/[^\d,]/g, '').replace(/[^\d.]/g, '')
                                field.onChange(result)
                              }}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* EMAIL   */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.email`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              type="email"
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                            />
                          )}
                        />
                      </td>

                      {/* COUNTRY */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.country_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Country"
                              isLoading={productCountry?.isLoading}
                              options={productCountry?.data}
                              value={field.value ? productCountry?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => {
                                field.onChange(e?.value)
                                methods.setValue(`datavalue.${key}.province_id`, null)
                                methods.setValue(`datavalue.${key}.regency_id`, null)
                                methods.setValue(`datavalue.${key}.subdistrict_id`, null)
                                methods.setValue(`datavalue.${key}.village_id`, null)
                              }}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* PROVINCE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.province_id`}
                          render={({ field, fieldState }) => (
                            <Select
                              key={key}
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select province"
                              isLoading={productProvince?.isLoading}
                              options={productProvince?.data.filter((item: any) => item.country_id?.toString() === dataReview?.[key]?.country_id?.toString())}
                              value={field.value ? productProvince?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => {
                                field.onChange(e?.value)
                                methods.setValue(`datavalue.${key}.regency_id`, null)
                                methods.setValue(`datavalue.${key}.subdistrict_id`, null)
                                methods.setValue(`datavalue.${key}.village_id`, null)
                              }}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || !dataReview?.[key]?.country_id}
                            />
                          )}
                        />
                      </td>

                      {/* REGENCY */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.regency_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              key={key}
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select regency"
                              isLoading={productRegency?.isLoading}
                              options={productRegency?.data.filter((item: any) => item.province_id?.toString() === dataReview?.[key]?.province_id?.toString())}
                              value={field.value ? productRegency?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => {
                                field.onChange(e?.value)
                                methods.setValue(`datavalue.${key}.subdistrict_id`, null)
                                methods.setValue(`datavalue.${key}.village_id`, null)
                              }}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || (!dataReview?.[key]?.country_id || !dataReview?.[key]?.province_id)}
                            />
                          )}
                        />
                      </td>

                      {/* SUBDISTRICT */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.subdistrict_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select subdistrict"
                              isLoading={productSubdistrict?.isLoading}
                              options={productSubdistrict?.data.filter((item: any) => item.regency_id?.toString() === dataReview?.[key]?.regency_id?.toString())}
                              value={field.value ? productSubdistrict?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => {
                                field.onChange(e?.value)
                                methods.setValue(`datavalue.${key}.village_id`, null)
                              }}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || (!dataReview?.[key]?.country_id || !dataReview?.[key]?.province_id || !dataReview?.[key]?.regency_id)}
                            />
                          )}
                        />
                      </td>

                      {/* VILLAGE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.village_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select village"
                              isLoading={productVillage?.isLoading}
                              options={productVillage?.data.filter((item: any) => item.subdistrict_id?.toString() === dataReview?.[key]?.subdistrict_id?.toString())}
                              value={field.value ? productVillage?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || (!dataReview?.[key]?.country_id || !dataReview?.[key]?.province_id || !dataReview?.[key]?.regency_id || !dataReview?.[key]?.subdistrict_id)}
                            />
                          )}
                        />
                      </td>

                      {/* ADDRESS */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.address`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[300px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* DATE START  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.date_start`}
                          render={({ field, fieldState }) => (
                            <div className='w-[150px]'>
                              <DateInput
                                portalId="root-datepicker"
                                className={`${inputClass}`} 
                                error={fieldState.error?.message}
                                disabled={isProfileDisable}
                                placeholderText="Input date start"
                                ref={field.ref}
                                selected={field.value ? moment(field.value).toDate() : null}
                                onChange={value => field.onChange(moment(value).format("YYYY-MM-DD"))}
                              />
                            </div>
                          )}
                        />
                      </td>

                      {/* MAIN LOCATION */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.location_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select Main Location"
                                isLoading={dataMainLocation?.isLoadingMainLocation}
                                options={dataMainLocation?.dataMainLocation}
                                value={field.value ? dataMainLocation?.dataMainLocation.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "MAIN_LOCATION" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* DIVISION */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.divisi_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select division"
                                isLoading={dataDivision?.isLoading}
                                options={dataDivision?.data}
                                value={field.value ? dataDivision?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "DIVISION" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* DEPARTEMENT */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.department_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select departement"
                                isLoading={dataDepartement?.isLoadingDepartement}
                                options={dataDepartement?.dataDepartement.filter((item: any) => item.divisi_id?.toString() === dataReview?.[key]?.divisi_id?.toString())}
                                value={field.value ? dataDepartement?.dataDepartement.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "DEPARTEMENT" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* EMPLOYMENT TITLE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.job_position_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select employment title"
                                isLoading={dataEmploymentTitle?.isLoading}
                                options={dataEmploymentTitle?.data.filter((item: any) => item.divisi_id?.toString() === dataReview?.[key]?.divisi_id?.toString())}
                                value={field.value ? dataEmploymentTitle?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "EMPLOYMENT_TITLE" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* ROLE MANAGEMENT */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.group_position_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select Role management"
                                isLoading={dataRole?.isLoading}
                                options={dataRole?.data}
                                value={field.value ? dataRole?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "ROLE_MANAGEMENT" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* GENDER */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.marital_status`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Gender"
                              options={dataGender}
                              value={field.value ? dataGender.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* SALARY TYPE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.salary_type_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select Salary Type"
                                isLoading={dataSalaryType?.isLoading}
                                options={dataSalaryType?.data}
                                value={field.value ? dataSalaryType?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "SALARY_TYPE" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      <td className={borderTH}>{Number(status) === StatusEnum.Review ? "Review" : "Submit"}</td>
                      {dataPage?.status === 1 && <td className={borderTH}>
                        <div className='flex justify-center gap-3 items-center'>
                          {Number(status) === StatusEnum.Review && <ActionButton.Delete onClick={() => handleDeleteSingle(previewId)} />}
                          <FaRegSave
                            className={`h-[20px] w-[20px] cursor-pointer ${isProfileDisable ? "text-gray-400" : "" }`} 
                            onClick={() => (!isProfileDisable) && handleUpdateSingle(idexValue)} 
                          />
                        </div>
                      </td>}
                      {dataPage?.status === 1 && <td className={borderTH}>
                        <div className='flex justify-center gap-3 items-center'>
                          <input 
                            type='checkbox'
                            className='w-[22px] h-[22px] checkbox checkbox-primary'
                            checked={checkedIndexes.includes(key)}
                            onChange={() => handleCheckboxChange(key)}
                            disabled={isProfileDisable}
                            >
                            
                          </input>
                        </div>
                      </td>}
                    </tr>
                  )
                })
              }
            </tbody>
          </BaseTable>
        </div>
      </FormProvider>
      <div className="mt-5 flex justify-between">
        <div className='w-[50%] mt-[-20px]'>
          <PaginationData data={dataSingle?.data} pagination={pagination} setPagination={setPagination} />
        </div>
        <div className="flex justify-end">
          <div className="flex gap-3">
            <Button color="error" onClick={() =>  navigate(-1)}>CANCEL</Button>
            {dataPage?.status === 1 && <Button color="primary" disabled={isDisabled && selectedData?.length === 0} onClick={handleCreateSingle}>SUBMIT {`${selectedData?.length !== 0 ? "ITEMS" : ""}`}</Button>}
          </div>
        </div>
      </div>

      {/* RELIGION */}
      {modalConfig?.show && modalConfig?.action === "RELIGION" && (
        <PopupReligion
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataReligion?.refetch()
          }}
        />
      )}

      {/* MAIN LOCATION */}
      {modalConfig?.show && modalConfig?.action === "MAIN_LOCATION" && (
        <PopupMainLocation
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataMainLocation?.refetch()
          }}
        />
      )}

      {/* DIVISION */}
      {modalConfig?.show && modalConfig?.action === "DIVISION" && (
        <PopupDivisi
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataDivision?.refetch()
          }}
        />
      )}

      {/* DEPARTEMENT */}
      {modalConfig?.show && modalConfig?.action === "DEPARTEMENT" && (
        <PopupDepartement
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataDepartement?.refetch()
          }}
        />
      )}
      
      {/* EMPLOYMENT TITLE */}
      {modalConfig?.show && modalConfig?.action === "EMPLOYMENT_TITLE" && (
        <PopupEmploymentTitle
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataEmploymentTitle?.refetch()
          }}
        />
      )}

      {/* ROLE MANAGEMENT */}
      {modalConfig?.show && modalConfig?.action === "ROLE_MANAGEMENT" && (
        <PopupEmploymentTitle
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataRole?.refetch()
          }}
        />
      )}

      {/* SALARY TYPE */}
      {modalConfig?.show && modalConfig?.action === "SALARY_TYPE" && (
        <PopupSalaryType
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            dataRole?.refetch()
          }}
        />
      )}
    </section>
  )
}